export default {
  scoreImprovement: 'B021',
  scoreSimulations: 'B026',
};
